import { render, staticRenderFns } from "./submitlist.vue?vue&type=template&id=3bb5d83c&scoped=true&"
import script from "./submitlist.vue?vue&type=script&lang=js&"
export * from "./submitlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb5d83c",
  null
  
)

export default component.exports